import { render, staticRenderFns } from "./OrdersFBMShow.vue?vue&type=template&id=15c8900d&scoped=true"
import script from "./OrdersFBMShow.vue?vue&type=script&lang=js"
export * from "./OrdersFBMShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c8900d",
  null
  
)

export default component.exports